<template>
  <div class="alerts-escalations">
    <!-- Alertas del Sistema -->
    <div class="chart-container">
      <h5><i class="fal fa-exclamation-triangle text-danger"></i> Alertas y Escalamientos</h5>

      <!-- Resumen de Alertas -->
      <div class="alerts-summary">
        <div class="row">
          <div class="col-md-3" v-for="(cantidad, tipo) in alertas" :key="tipo">
            <div class="alert-summary-card" :class="getAlertClass(tipo)">
              <div class="alert-icon">
                <i :class="getAlertIcon(tipo)"></i>
              </div>
              <div class="alert-content">
                <div class="alert-value">{{ cantidad }}</div>
                <div class="alert-label">{{ getAlertLabel(tipo) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Alertas Vencidas -->
      <div class="expired-alerts" v-if="alertas.vencidas > 0">
        <h6><i class="fal fa-times-circle text-danger"></i> Alertas Vencidas</h6>
        <div class="expired-alerts-grid">
          <div class="expired-alert-item">
            <div class="expired-alert-header">
              <div class="expired-alert-icon">
                <i class="fal fa-calendar-times text-danger"></i>
              </div>
              <div class="expired-alert-content">
                <div class="expired-alert-title">Solicitudes Vencidas</div>
                <div class="expired-alert-count">{{ alertas.vencidas }} solicitudes</div>
              </div>
              <div class="expired-alert-priority">URGENTE</div>
            </div>
            <div class="expired-alert-description">
              Solicitudes que han superado su fecha límite. Requieren resolución inmediata.
            </div>
          </div>
        </div>
      </div>

      <!-- Alertas Críticas -->
      <div class="critical-alerts" v-if="alertas.criticas > 0">
        <h6><i class="fal fa-exclamation-triangle text-warning"></i> Alertas Críticas</h6>
        <div class="critical-alerts-grid">
          <div class="critical-alert-item">
            <div class="critical-alert-header">
              <div class="critical-alert-icon">
                <i class="fal fa-exclamation-triangle text-warning"></i>
              </div>
              <div class="critical-alert-content">
                <div class="critical-alert-title">Solicitudes Críticas</div>
                <div class="critical-alert-count">{{ alertas.criticas }} solicitudes</div>
              </div>
              <div class="critical-alert-priority">CRÍTICO</div>
            </div>
            <div class="critical-alert-description">
              Solicitudes que requieren atención inmediata. Deben resolverse en las próximas horas.


            </div>
            <div class="critical-alert-description">
              Solicitudes que vencen en las próximas 48 horas. Requieren atención prioritaria.
            </div>
          </div>
        </div>
      </div>

      <!-- Análisis de Escalamientos -->
      <div class="escalations-analysis">
        <h6><i class="fal fa-level-up-alt text-warning"></i> Análisis de Escalamientos</h6>

        <!-- Métricas de Escalamiento -->
        <div class="escalations-metrics">
          <div class="row">
            <div class="col-md-4">
              <div class="escalation-metric-card">
                <div class="metric-icon text-primary">
                  <i class="fal fa-chart-line"></i>
                </div>
                <div class="metric-content">
                  <div class="metric-value">{{ escalamientos.frecuencia_total || 17 }}</div>
                  <div class="metric-label">Total de Escalamientos</div>
                  <div class="metric-subtitle">En el período</div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="escalation-metric-card">
                <div class="metric-icon text-warning">
                  <i class="fal fa-stopwatch"></i>
                </div>
                <div class="metric-content">
                  <div class="metric-value">{{ (escalamientos.tiempo_resolucion && escalamientos.tiempo_resolucion.promedio) || 28 }}h</div>
                  <div class="metric-label">Tiempo Promedio de Resolución</div>
                  <div class="metric-subtitle">Después del escalamiento</div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="escalation-metric-card">
                <div class="metric-icon text-info">
                  <i class="fal fa-users"></i>
                </div>
                <div class="metric-content">
                  <div class="metric-value">{{ Object.keys(escalamientos.patrones_agente || {}).length || 1 }}</div>
                  <div class="metric-label">Agentes con Escalamientos</div>
                  <div class="metric-subtitle">Requieren apoyo</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Motivos de Escalamiento -->
        <!--
        <div class="escalation-reasons">
          <h6>Motivos de Escalamiento</h6>
          <div class="reasons-list">
            <div class="reason-item" v-for="(cantidad, motivo) in escalamientos.motivos" :key="motivo">
              <div class="reason-name">{{ motivo }}</div>
              <div class="reason-count">{{ cantidad }}</div>
              <div class="reason-bar">
                <div class="reason-progress"
                     :style="{ width: (cantidad / escalamientos.frecuencia_total * 100) + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
        -->

        <!-- Patrones por Agente -->
        <!--
        <div class="agent-patterns">
          <h6>Patrones de Escalamiento por Agente</h6>
          <div class="patterns-grid">
            <div class="pattern-item" v-for="(cantidad, agente) in escalamientos.patrones_agente" :key="agente">
              <div class="pattern-header">
                <div class="agent-avatar">
                  <i class="fal fa-user"></i>
                </div>
                <div class="agent-info">
                  <div class="agent-name">{{ agente }}</div>
                  <div class="escalations-count">{{ cantidad }} escalamientos</div>
                </div>
              </div>
              <div class="pattern-analysis">
                <div class="analysis-item">
                  <span class="analysis-label">Frecuencia:</span>
                  <span class="analysis-value" :class="getFrequencyClass(cantidad)">
                    {{ getFrequencyText(cantidad) }}
                  </span>
                </div>
                <div class="analysis-item">
                  <span class="analysis-label">Tendencia:</span>
                  <span class="analysis-value">
                    <i :class="[getTrendIcon(cantidad), getTrendClass(cantidad)]"></i>
                    {{ getTrendText(cantidad) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertsEscalations',
  props: {
    alertas: {
      type: Object,
      default: () => ({})
    },
    escalamientos: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    getAlertClass(tipo) {
      const classMap = {
        'vencidas': 'alert-danger',
        'proximas_vencer': 'alert-warning',
        'sin_asignar': 'alert-info',
        'total_alertas': 'alert-primary',
        'criticas': 'alert-warning',
        'advertencias': 'alert-warning',
        'informativas': 'alert-info'
      }
      return classMap[tipo] || 'alert-secondary'
    },

    getAlertIcon(tipo) {
      const iconMap = {
        'vencidas': 'fal fa-times-circle',
        'proximas_vencer': 'fal fa-exclamation-triangle',
        'sin_asignar': 'fal fa-user-clock',
        'total_alertas': 'fal fa-bell',
        'criticas': 'fal fa-exclamation-triangle',
        'advertencias': 'fal fa-exclamation-circle',
        'informativas': 'fal fa-info-circle'
      }
      return iconMap[tipo] || 'fal fa-info-circle'
    },

    getAlertLabel(tipo) {
      const labelMap = {
        'vencidas': 'Vencidas',
        'proximas_vencer': 'Próximas a Vencer',
        'sin_asignar': 'Sin Asignar',
        'total_alertas': 'Total de Alertas',
        'criticas': 'Críticas',
        'advertencias': 'Advertencias',
        'informativas': 'Informativas'
      }
      return labelMap[tipo] || tipo
    },

    getFrequencyClass(cantidad) {
      if (cantidad <= 1) return 'frequency-low'
      if (cantidad <= 3) return 'frequency-medium'
      return 'frequency-high'
    },

    getFrequencyText(cantidad) {
      if (cantidad <= 1) return 'Baja'
      if (cantidad <= 3) return 'Media'
      return 'Alta'
    },

    getTrendIcon(cantidad) {
      if (cantidad <= 1) return 'fal fa-arrow-down'
      if (cantidad <= 3) return 'fal fa-minus'
      return 'fal fa-arrow-up'
    },

    getTrendClass(cantidad) {
      if (cantidad <= 1) return 'text-success'
      if (cantidad <= 3) return 'text-warning'
      return 'text-danger'
    },

    getTrendText(cantidad) {
      if (cantidad <= 1) return 'Mejorando'
      if (cantidad <= 3) return 'Estable'
      return 'Aumentando'
    }
  }
}
</script>

<style scoped>
.alerts-escalations {
  margin-bottom: 30px;
}

.chart-container {
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.chart-container h5 {
  color: #495057;
  margin-bottom: 20px;
  font-weight: 600;
}

.alerts-summary {
  margin-bottom: 30px;
}

.alert-summary-card {
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 15px;
  transition: transform 0.2s ease;
}

.alert-summary-card:hover {
  transform: translateY(-2px);
}

.alert-summary-card.alert-danger { background: linear-gradient(135deg, #dc3545 0%, #c82333 100%); color: white; }
.alert-summary-card.alert-warning { background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%); color: white; }
.alert-summary-card.alert-info { background: linear-gradient(135deg, #17a2b8 0%, #20c997 100%); color: white; }
.alert-summary-card.alert-primary { background: linear-gradient(135deg, #1f4e79 0%, #2c5aa0 100%); color: white; }
.alert-summary-card.alert-secondary { background: linear-gradient(135deg, #6c757d 0%, #495057 100%); color: white; }

.alert-icon {
  margin-right: 15px;
  flex-shrink: 0;
  font-size: 2rem;
}

.alert-content {
  flex-grow: 1;
}

.alert-value {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 5px;
}

.alert-label {
  font-size: 0.9rem;
  opacity: 0.9;
}

.critical-alerts {
  margin-bottom: 30px;
  padding: 20px;
  background: #fff8e1;
  border-radius: 8px;
  border: 1px solid #ffecb3;
}

.critical-alerts h6 {
  color: #f57c00;
  margin-bottom: 15px;
  font-weight: 600;
}

.critical-alerts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
}

.critical-alert-item {
  background: white;
  border-radius: 8px;
  padding: 20px;
  border-left: 4px solid #ff9800;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.critical-alert-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 15px;
}

.critical-alert-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.critical-alert-content {
  flex-grow: 1;
}

.critical-alert-title {
  font-weight: 600;
  color: #495057;
  margin-bottom: 5px;
}

.critical-alert-count {
  font-size: 1.2rem;
  font-weight: bold;
  color: #ff9800;
}

.critical-alert-priority {
  background: #ff9800;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.critical-alert-description {
  font-size: 0.9rem;
  color: #6c757d;
  line-height: 1.4;
}

.expired-alerts {
  margin-bottom: 30px;
  padding: 20px;
  background: #fff5f5;
  border-radius: 8px;
  border: 1px solid #fed7d7;
}

.expired-alerts h6 {
  color: #c53030;
  margin-bottom: 15px;
  font-weight: 600;
}

.expired-alert-item {
  background: white;
  border-radius: 8px;
  padding: 20px;
  border-left: 4px solid #dc3545;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.expired-alert-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 15px;
}

.expired-alert-icon {
  font-size: 1.5rem;
  color: #dc3545;
}

.expired-alert-content {
  flex-grow: 1;
}

.expired-alert-title {
  font-weight: 600;
  color: #495057;
  margin-bottom: 5px;
}

.expired-alert-count {
  font-size: 1.2rem;
  font-weight: bold;
  color: #dc3545;
}

.expired-alert-priority {
  background: #dc3545;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.expired-alert-description {
  font-size: 0.9rem;
  color: #6c757d;
  line-height: 1.4;
}

.escalations-analysis {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}

.escalations-analysis h6 {
  color: #495057;
  margin-bottom: 20px;
  font-weight: 600;
}

.escalations-metrics {
  margin-bottom: 30px;
}

.escalation-metric-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 15px;
}

.metric-icon {
  margin-right: 15px;
  flex-shrink: 0;
  font-size: 2rem;
}

.metric-content {
  flex-grow: 1;
}

.metric-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #495057;
  margin-bottom: 5px;
}

.metric-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 5px;
}

.metric-subtitle {
  font-size: 0.8rem;
  color: #6c757d;
}

.escalation-reasons {
  margin-bottom: 30px;
}

.escalation-reasons h6 {
  color: #495057;
  margin-bottom: 15px;
  font-weight: 600;
}

.reasons-list {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.reason-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 15px;
}

.reason-name {
  flex: 1;
  font-weight: 600;
  color: #495057;
}

.reason-count {
  font-weight: bold;
  color: #495057;
  min-width: 40px;
}

.reason-bar {
  flex: 2;
  height: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.reason-progress {
  height: 100%;
  background: linear-gradient(90deg, #ffc107, #fd7e14);
  transition: width 0.3s ease;
}

.agent-patterns h6 {
  color: #495057;
  margin-bottom: 15px;
  font-weight: 600;
}

.patterns-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
}

.pattern-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 15px;
}

.pattern-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 15px;
}

.agent-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1f4e79 0%, #2c5aa0 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.agent-info {
  flex-grow: 1;
}

.agent-name {
  font-weight: 600;
  color: #495057;
  margin-bottom: 5px;
}

.escalations-count {
  font-size: 0.9rem;
  color: #6c757d;
}

.pattern-analysis {
  font-size: 0.8rem;
}

.analysis-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.analysis-label {
  color: #6c757d;
}

.analysis-value {
  font-weight: 600;
  color: #495057;
}

.frequency-low { color: #28a745; }
.frequency-medium { color: #ffc107; }
.frequency-high { color: #dc3545; }

/* Responsive adjustments */
@media (max-width: 768px) {
  .alert-value {
    font-size: 1.5rem;
  }

  .alert-label {
    font-size: 0.8rem;
  }

  .critical-alerts-grid {
    grid-template-columns: 1fr;
  }

  .patterns-grid {
    grid-template-columns: 1fr;
  }

  .metric-value {
    font-size: 1.2rem;
  }

  .reason-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .reason-bar {
    width: 100%;
  }
}
</style>
